import { zfd } from 'zod-form-data';
import { makeCrewClaimAction, redirect } from '~/utils/routing';
import { addressFormSchema, addressSchemaRequiredPhone } from '~/utils/schemas';
import { isAddressPhoneRequired } from '~/utils/theme';

export const { action, useActionResult } = makeCrewClaimAction(
  ({ formData, context }, appStore) => {
    const schema =
      (
        isAddressPhoneRequired(
          context.settings.theme,
          context.crewClaim.claimType,
        )
      ) ?
        addressSchemaRequiredPhone
      : addressFormSchema;

    const result = zfd
      .formData({
        address: schema,
      })
      .safeParse(formData);

    if (!result.success) {
      return {
        ok: false,
        message: 'Invalid address. Check your address information.',
      };
    }

    appStore.dispatch(
      appStore.actions.crewClaim.setAddress(result.data.address),
    );

    return redirect(`..`);
  },
);
